import ConsumerCardSubInfo from './ConsumerCardSubInfo';

export default ConsumerCardSubInfo;
